import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.css']
})
export class RadioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
